<template>
	<div class="relative flex h-11 w-11 items-center justify-center">
		<svg
			width="53"
			height="53"
			viewBox="0 0 53 53"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="absolute -top-[3.5px] -left-[4.5px]"
		>
			<g filter="url(#filter0_d_1635_17085)">
				<path
					d="M22.2651 7.08132C24.7438 5.23955 28.1365 5.23956 30.6151 7.08132L43.3548 16.5476C45.7533 18.3298 46.756 21.438 45.8512 24.2858L40.9219 39.8015C39.9986 42.7078 37.3 44.682 34.2505 44.682H18.6297C15.5803 44.682 12.8817 42.7078 11.9583 39.8015L7.029 24.2858C6.12425 21.438 7.12698 18.3298 9.52543 16.5476L22.2651 7.08132Z"
					fill="url(#paint0_linear_1635_17085)"
				/>
				<path
					d="M22.2651 7.08132C24.7438 5.23955 28.1365 5.23956 30.6151 7.08132L43.3548 16.5476C45.7533 18.3298 46.756 21.438 45.8512 24.2858L40.9219 39.8015C39.9986 42.7078 37.3 44.682 34.2505 44.682H18.6297C15.5803 44.682 12.8817 42.7078 11.9583 39.8015L7.029 24.2858C6.12425 21.438 7.12698 18.3298 9.52543 16.5476L22.2651 7.08132Z"
					fill="#0A0A0A"
					:fill-opacity="active ? 0.37 : 0.71"
				/>
			</g>
			<g filter="url(#filter1_d_1635_17085)">
				<path
					d="M21.7378 6.39549C24.5417 4.35834 28.3385 4.35834 31.1424 6.39549L42.6611 14.7643C45.465 16.8015 46.6382 20.4124 45.5673 23.7086L41.1675 37.2496C40.0965 40.5458 37.0249 42.7775 33.5591 42.7775H19.3212C15.8554 42.7775 12.7837 40.5458 11.7127 37.2496L7.31299 23.7086C6.242 20.4124 7.41526 16.8015 10.2192 14.7643L21.7378 6.39549Z"
					fill="#222222"
				/>
				<path
					d="M21.7378 6.39549C24.5417 4.35834 28.3385 4.35834 31.1424 6.39549L42.6611 14.7643C45.465 16.8015 46.6382 20.4124 45.5673 23.7086L41.1675 37.2496C40.0965 40.5458 37.0249 42.7775 33.5591 42.7775H19.3212C15.8554 42.7775 12.7837 40.5458 11.7127 37.2496L7.31299 23.7086C6.242 20.4124 7.41526 16.8015 10.2192 14.7643L21.7378 6.39549Z"
					fill="url(#paint1_linear_1635_17085)"
				/>
				<path
					d="M22.3259 7.20467C24.7792 5.42224 28.101 5.42224 30.5544 7.20467L42.0729 15.5728C44.5263 17.3553 45.553 20.5158 44.6159 23.4L40.2165 36.941C39.2793 39.8249 36.5916 41.7778 33.5593 41.7779H19.321C16.2886 41.7778 13.601 39.8249 12.6638 36.941L8.26434 23.4C7.32722 20.5158 8.3539 17.3553 10.8073 15.5728L22.3259 7.20467Z"
					stroke="url(#paint2_linear_1635_17085)"
					stroke-width="2"
				/>
			</g>
			<path
				d="M23.5009 8.79673C25.2533 7.52357 27.6264 7.52369 29.3788 8.79673L40.9218 17.1834C42.6742 18.4566 43.4075 20.7132 42.7382 22.7733L38.329 36.3436C37.6596 38.4035 35.7401 39.7977 33.5742 39.7977H19.3066C17.1405 39.7977 15.2202 38.4036 14.5507 36.3436L10.1415 22.7733C9.47241 20.7133 10.2057 18.4566 11.9579 17.1834L23.5009 8.79673Z"
				stroke="url(#paint3_linear_1635_17085)"
				stroke-width="2"
			/>
			<defs>
				<filter
					id="filter0_d_1635_17085"
					x="-4.86374e-05"
					y="-2.86102e-06"
					width="52.8803"
					height="52.382"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1" />
					<feGaussianBlur stdDeviation="3.35" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.05125 0 0 0 0 0.0682143 0 0 0 0 0.09875 0 0 0 0.42 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_1635_17085"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_1635_17085"
						result="shape"
					/>
				</filter>
				<filter
					id="filter1_d_1635_17085"
					x="4.9209"
					y="4.86762"
					width="43.0385"
					height="43.9098"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="1" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_1635_17085"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_1635_17085"
						result="shape"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_1635_17085"
					x1="26.4401"
					y1="42.6041"
					x2="26.4401"
					y2="47.4791"
					gradientUnits="userSpaceOnUse"
				>
					<stop :stop-color="active ? '#593827' : '#868686'" />
					<stop offset="1" :stop-color="active ? '#593827' : '#868686'" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1635_17085"
					x1="26.4401"
					y1="2.97908"
					x2="26.4401"
					y2="46.9791"
					gradientUnits="userSpaceOnUse"
				>
					<stop :stop-color="active ? '#F29867' : '#868686'" stop-opacity="0" />
					<stop
						offset="1"
						:stop-color="active ? '#F29867' : '#868686'"
						stop-opacity="0.3"
					/>
				</linearGradient>
				<linearGradient
					id="paint2_linear_1635_17085"
					x1="26.4401"
					y1="2.97908"
					x2="26.4401"
					y2="46.9791"
					gradientUnits="userSpaceOnUse"
				>
					<stop :stop-color="active ? '#F29867' : '#868686'" stop-opacity="0" />
					<stop
						offset="1"
						:stop-color="active ? '#F29867' : '#868686'"
						stop-opacity="0.31"
					/>
				</linearGradient>
				<linearGradient
					id="paint3_linear_1635_17085"
					x1="26.6015"
					y1="5.42564"
					x2="26.6015"
					y2="44.5326"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						:stop-color="active ? '#F29867' : '#868686'"
						stop-opacity="0.2"
					/>
					<stop
						offset="1"
						:stop-color="active ? '#F29867' : '#868686'"
						stop-opacity="0"
					/>
				</linearGradient>
			</defs>
		</svg>
		<div
			class="relative"
			:class="{ 'text-label-secondary': !active, 'text-label-primary': active }"
		>
			<slot />
		</div>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	active?: boolean
}>()
</script>
